<template>
  <div
    v-if="shown"
    id="markups-minimized-popup"
    class="markups-minimized-popup"
    :class="{ animate: shown }">
    <div class="markup-minimized-header">
      <div class="markup-minimized-header-text vertical-center">Markups</div>
      <div class="markups-minimized-popup-close" @click="hidePopup">X</div>
    </div>
    <div class="content-container">
      <img :src="attachmentImageUrl" :alt="attachmentName" />
      <div class="document-details disable-select">
        <div class="document-data-title">Document Name</div>
        <div class="document-data-content">{{ attachmentName }}</div>
        <div class="open-markups-btn" v-has="permissions.Markups.View" @click="openMarkupsPopup">
          <img :src="maximizeImg" alt="Open Markups" />
          <span>Open Markups</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import { PopupStatus } from '../../scripts/js/forgeService';
  import permissions from '@Share/config/permissions';
  // var imagesFolderPath = (apiUrl ? apiUrl : '../../') + 'images/';
  var imagesFolderPath = '../../' + 'images/';
  export default {
    name: 'markup-popup-minimized',
    props: [],
    data() {
      return {
        permissions,
        maximizeImg: imagesFolderPath + 'maximize.svg',
      };
    },
    components: {},
    methods: {
      show() {
        $('.format-popup').css('display', 'flex');
      },
      hidePopup() {
        this.$store.commit('setMarkupsPopupStatus', PopupStatus.UNDEFINED);
      },
      openMarkupsPopup() {
        this.$store.commit('setMarkupsPopupStatus', PopupStatus.ACTIVE);
      },
    },
    computed: {
      attachmentImageUrl: {
        get: function () {
          return this.attachment?.imageUrl ?? '';
        },
      },
      attachmentName: {
        get: function () {
          return this.attachment?.name ?? '';
        },
      },
      attachment: function () {
        return this.$store.state.MARKUPS.activeAttachment;
      },
      shown: function () {
        var status = this.$store.state.MARKUPS.markupsPopupStatus;
        return status?.toLowerCase() == PopupStatus.MINIMIZED;
      },
    },
  };
</script>

<style>
  .markups-minimized-popup {
    height: 200px;
    width: 285px;
    margin: 20px;
    right: 0;
    display: block;
    flex-direction: column;
    background: #ffffff;
    color: white;
    position: absolute;
    overflow: hidden;
    z-index: 10;
    border-radius: 10px;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
    opacity: 0;
  }

  .animate {
    animation: minimize;
    animation-delay: 2s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }

  @keyframes minimize {
    form {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .markup-minimized-header {
    display: flex;
    background-color: var(--v-primary-base);
    color: white;
    font-size: 17px;
    padding: 2px;
    position: relative;
    min-height: 45px;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
    user-select: none;
    z-index: 100;
  }

  .markup-minimized-header-text {
    width: 50%;
    left: 20px;
    font-family: var(--main-font);
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
  }

  .markups-minimized-popup-close {
    font-weight: 500;
    font-size: 12px;
    padding-top: 2px;
    font-family: 'Popins', sans-serif;
    background-color: white;
    color: var(--v-primary-base);
    border-radius: 18pc;
    width: 22px;
    height: 20px;
    text-align: center;
    margin: 12px;
    position: absolute;
    cursor: pointer;
    z-index: 10;
    right: 0;
    top: 0;
  }

  .markups-minimized-popup-close:hover {
    background-color: var(--v-primary-darken2);
    color: white;
  }

  .content-container {
    display: flex;
    height: 155px;
  }

  .content-container img {
    position: relative;
    height: 120px;
    width: 90px;
    margin: 15px;
    border-radius: 5px;
  }

  .document-details {
    padding: 10px;
  }

  .document-data-title {
    position: relative;
    font-family: var(--main-font);
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    text-align: left;
    text-transform: uppercase;
    color: #bdbdbd;
  }

  .document-data-content {
    position: relative;
    font-family: var(--main-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    text-transform: uppercase;
    color: #333333;
    height: 60px;
    overflow: hidden;
    word-break: break-word;
  }

  .open-markups-btn {
    position: absolute;
    bottom: 15px;
    width: 135px;
    height: 40px;
    display: flex;
    background: var(--v-primary-base);
    border-radius: 5px;
    font-family: var(--main-font);
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: #ffffff;
    cursor: pointer;
  }

  .open-markups-btn:hover {
    background: var(--v-primary-darken2);
  }

  .open-markups-btn span {
    margin: 14px 5px;
  }

  .open-markups-btn img {
    height: 25px;
    width: 25px;
    margin: 7.5px;
  }
</style>
